import { render, staticRenderFns } from "./CTC.vue?vue&type=template&id=6c88a3ec&scoped=true&"
var script = {}
import style0 from "./CTC.vue?vue&type=style&index=0&id=6c88a3ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c88a3ec",
  null
  
)

export default component.exports